import { Injectable } from '@angular/core';
import { ResourceGroupModel } from '../../../../core/models/resources/resource-group.model';
import { HttpService } from '../http-service/http.service';
import { ResourceContentService } from '../content/resource-content.service';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export class ResourceGroupService extends ResourceContentService<ResourceGroupModel> {
    constructor(protected override httpService: HttpService<ResourceGroupModel>) {
        super(httpService);
    }

    getResourceUrl(): string {
        return 'resourceGroups';
    }
}
